module.exports = __webpack_public_path__ + "img/gnxs.43a06bbe.png";